<template>
  <Modal @close="$emit('close')">
    <template #header>
      <div class="w-full text-center">
        <h1 class="text-2xl">
          {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.title') }}
        </h1>
      </div>
    </template>

    <template #body>
      <div class="min-w-md h-full w-full">
        <form
          class="flex flex-col space-y-4"
          @submit.prevent="saveVariationOrder"
        >
          <div class="font-semibold text-lg">
            {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.date') }} {{ new Date().toLocaleDateString() }}
          </div>

          <div>
            <div class="flex justify-between text-lg">
              <span>{{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.delay') }}</span>

              <span class="font-semibold">{{ delay.code }}</span>
            </div>

            <p>
              {{ delay.description }}
            </p>
          </div>

          <div class="flex flex-col space-y-2">
            <p class="font-semibold text-lg">
              {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.variationDetails') }}
            </p>

            <label>
              {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.label.description') }}
              <textarea
                v-model="variationOrderForm.form.description"
                name="description"
                class="form-input resize-none"
              />
            </label>

            <label>
              {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.label.notes') }}
              <textarea
                v-model="variationOrderForm.form.notes"
                name="notes"
                class="form-input resize-none"
              />
            </label>
          </div>
        </form>
      </div>
    </template>

    <template #footer>
      <div class="w-full flex justify-end space-x-4">
        <button
          type="button"
          class="btn btn--secondary-blue"
          @click="$emit('close')"
        >
          {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.button.cancel') }}
        </button>

        <button
          type="button"
          class="btn btn--primary-blue"
          data-test="apply-filter"
          @click="saveVariationOrder"
        >
          {{ $t('HeadContract.DelaysSchedule.DelayAttachVariationModal.button.create') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import Delay from '@/models/Delay';
import { useDelaysStore } from '@/store/delays';
import { useVariationOrdersStore } from '@/store/variationOrders';
import Swal from 'sweetalert2';
import { computed } from 'vue';

const props = defineProps<{
  projectId: string;
  delayId: Id;
}>();

const emits = defineEmits<{
  (e: 'close');
}>();

const delaysStore = useDelaysStore();
const attachVariationOrderAction = useStoreApiAction(delaysStore.attachVariationOrder);

const variationOrderForm = useFormData({
  description: '',
  notes: '',
});

const delay = computed(() => {
  return delaysStore.models.find(props.delayId);
});

const saveVariationOrder = () => {
  attachVariationOrderAction.request(props.delayId, variationOrderForm.form).then((variationOrder) => {
    Swal.fire({
      icon: 'success',
      text: 'Variation attached to delay.',
    }).then(() => {
      emits('close');
    });
  }).catch((error) => {
    variationOrderForm.setErrors(error.data);
  });
};
</script>

<style scoped></style>
